import { createSelector } from '@ngrx/store';
import { getMessagesState } from '../messages.selectors';

export const notificationsState = createSelector(
  getMessagesState,
  (state) => state.notificationsState
);
export const notificationsData = createSelector(notificationsState, (state) => state.data);

export const notificationsIsLoading = createSelector(
  notificationsState,
  (state) => state.isLoading
);
export const notificationsSuccess = createSelector(
  notificationsState,
  (state) => state.success
);
export const notificationsError = createSelector(
  notificationsState,
  (state) => state.error
);

export const notificationsHasBeenFetched = createSelector(
  notificationsState,
  (state) => state.fetched
);
